import { API } from "aws-amplify";
import { getYearlyReportSummary } from "~/graphql/queries";
import * as APITypes from "~/API";

export const EMPTY_YEARLY_REPORT: APITypes.YearlyReportSummary = {
  __typename: "YearlyReportSummary",
  id: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  entityID: "",
  entityType: "",
  year: 0,
  createdAt: "",
  updatedAt: "",
  _version: 0,
  _lastChangedAt: 0,
};

export const getYearlyReport = async (reportId: string) => {
  try {
    const response = (await API.graphql({
      query: getYearlyReportSummary,
      variables: {
        id: reportId,
      },
    })) as { data?: APITypes.GetYearlyReportSummaryQuery };

    return {
      success: true,
      data: response.data?.getYearlyReportSummary || EMPTY_YEARLY_REPORT,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_YEARLY_REPORT,
      error,
    };
  }
};
